<template>
  <div>
    <v-dialog v-model="dialog" max-width="400">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="notUppercase"
          v-bind="attrs"
          v-on="on"
          :small="params.includes('small')"
          :x-small="params.includes('x-small')"
          :outlined="params.includes('outlined')"
          :block="params.includes('block')"
          :color="buttonColor"
          depressed
        >
          <v-icon x-small color="primary" class="mx-1">mdi-cog</v-icon>
          <span v-if="!noVertex"
            >Vertex: {{ vertexDistance_ext * 1000 }}mm</span
          >
          <span v-if="!noRound && !noVertex">, </span>
          <span v-if="!noRound" class="ml-2">Round: {{ round_ext }}D</span>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="d-flex flex-row align-center orangeCardTitle">
          <div>
            <span v-if="!noVertex">Vertex Distance </span>
            <span v-if="!noRound && !noVertex"> &amp; </span>
            <span v-if="!noRound">Rounding </span>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false" color="primary"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <!-- {{ vertexDistance }}{{ vertexDistance_ext }} -->
        <v-divider></v-divider>
        <v-card-text class="pa-3 darkerCardText">
          <!-- <div>Choose</div> -->
          <div class="mb-4">
            <div class="overline">Round results to</div>
            <v-btn-toggle
              v-model="roundTo"
              rounded
              mandatory
              dense
              class="toggleBtns mx-2 blooBerder"
              active-class="orangeActive"
            >
              <v-btn small :value="0.01">0.01</v-btn>
              <v-btn small :value="0.125">0.125</v-btn>
              <v-btn small :value="0.25">0.25</v-btn> </v-btn-toggle
            >D
          </div>
          <div class="mb-4">
            <div class="overline">Refraction Vertex Distance</div>
            <v-btn
              v-for="val in vertexButtonValues"
              :key="val"
              @click="setVertexDistance(val)"
              small
              depressed
              :color="val != vertexDistance ? 'primary' : '#f7dea5'"
              :outlined="val != vertexDistance"
              class="ma-1 notUppercase"
              :class="val == vertexDistance ? 'outlineButton' : ''"
              >{{ val }} mm</v-btn
            >
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="doCancel()" outlined depressed color="primary"
            >Cancel</v-btn
          >
          <v-btn @click="emitAndClose" depressed color="green lighten-3"
            >Accept</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "VertexAndRoundDialog",
  props: {
    noVertex: null,
    noRound: null,
    units: {
      type: String,
      default: "m", // or "mm"
    },
    minVal: {
      type: Number,
      default: 5,
    },
    maxVal: {
      type: Number,
      default: 24,
    },
    params: {
      type: Array,
      default: () => [],
    },
    buttonColor: {
      type: String,
      default: "primary",
    },
    vertexDistance_ext: { type: Number, default: 12 }, // if want to set from external
    round_ext: { type: Number, default: 0.25 }, // if want to set from external
  },
  data: function () {
    return {
      dialog: false,
      vertexDistance: 12,
      roundTo: 0.25,
    };
  },
  methods: {
    setVertexDistance(val) {
      // console.log(val);
      if (!val) return;
      if (val < 0.1) val *= 1000; // if it's small assume it's in m and convert to mm
      if (val < this.minVal) val = this.minVal;
      if (val > this.maxVal) val = this.maxVal;
      this.vertexDistance = val;
      //   let unit = this.units == "mm" ? 1 : 1000;
      //   this.$emit("newSet", val / unit);
      //   this.dialog = false;
    },
    emitAndClose() {
      let unit = this.units == "mm" ? 1 : 1000;
      let emit = {};
      emit.vertexDistance = this.vertexDistance / unit;
      emit.round = this.roundTo;
      this.$emit("change", emit);
      this.dialog = false;
    },
    doCancel() {
      this.roundTo = this.round_ext;
      this.vertexDistance = this.setVertexDistance(this.vertexDistance_ext);
      this.dialog = false;
    },
  },
  computed: {
    vertexButtonValues: function () {
      let start = this.minVal;
      let stop = this.maxVal;
      return [...Array(stop + 1).keys()].slice(start);
    },
  },
  watch: {
    vertexDistance_ext: {
      handler: function (val) {
        if (val) this.setVertexDistance(val);
      },
      immediate: true,
    },
    round_ext: {
      handler: function (val) {
        // console.log(this.roundTo);
        if (val) this.roundTo = val;
      },
      immediate: true,
    },
  },
  mounted() {
    // console.log(this.roundTo);
    if (this.vertexDistance_ext)
      this.setVertexDistance(this.vertexDistance_ext);
    if (this.round_ext) this.roundTo = this.round_ext;
  },
};
</script>

<style scoped>
.notUppercase {
  text-transform: unset !important;
}
.outlineButton {
  border: 1px solid #1876d2 !important;
}
.toggleBtns.v-btn-toggle.blooBerder >>> button.v-btn {
  border-color: rgb(24 118 210) !important;
}
</style>
